import { render, staticRenderFns } from "./HeaderDeContasAReceber.vue?vue&type=template&id=17a6b8d5&scoped=true"
import script from "./HeaderDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeContasAReceber.vue?vue&type=style&index=0&id=17a6b8d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6b8d5",
  null
  
)

export default component.exports